import * as React from "react";
import { NativeSelect, NativeSelectOption } from "./ui/native-select";

export interface SelectOption {
  label: string;
  value: string;
  disabled?: boolean;
}

/** Custom dropdown select, styled to match Field. */
export interface SelectProps {
  options: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  /** @default "Select…" */
  placeholder?: string;
  label?: string;
  hint?: string;
  disabled?: boolean;
  /** @default "md" */
  size?: "sm" | "md";
  style?: React.CSSProperties;
}


/** One native select preserves empty-value clearing and browser keyboard behavior. */
export function Select({options, value = "", onChange, placeholder = "Select…", label, hint,
  disabled = false, size = "md", style}: SelectProps) {
  const id = React.useId();
  const hintId = hint ? `${id}-hint` : undefined;
  return <div className="block font-sans" style={style}>
    {label && <label htmlFor={id} className="mb-1.5 block text-[length:var(--text-label)] font-bold text-[var(--text-secondary)]">{label}</label>}
    <NativeSelect id={id} value={value} onChange={e => onChange?.(e.target.value)}
      aria-label={label ?? placeholder} aria-describedby={hintId} disabled={disabled} size={size === "sm" ? "sm" : "default"}>
      {!options.some(option => option.value === value) && <NativeSelectOption value={value} disabled hidden>{placeholder}</NativeSelectOption>}
      {options.map(option => <NativeSelectOption key={option.value} value={option.value} disabled={option.disabled}>{option.label}</NativeSelectOption>)}
    </NativeSelect>
    {hint && <div id={hintId} className="mt-1.5 text-[length:var(--text-body-sm)] text-muted-foreground">{hint}</div>}
  </div>;
}
